import { sCAuth } from "schmucklicloud_auth";
import { sCStorage } from "schmucklicloud_storage"; 

//Note: Also change these value in public/oauth_complete.html since it is a static website
const APP_ID = "f126b8131bf931e16cea269fc896f07fa37e306f";
const APP_SECRET = "f25252a841c1df29eda24e600bac661b52c81434564024e8f6afa4022a7a5ea7";

var auth = new sCAuth(APP_ID, APP_SECRET);
var storage = new sCStorage(APP_ID, APP_SECRET);
storage.setBucket(18);

var session_token = window.localStorage.getItem("session_token");
storage.setAuthToken(session_token);

export { auth, storage };